import '../scss/plexiglas.scss';
import './product-price';
import './tooltip';
// import './checkout';

jQuery(function ($) {
    $(document)
        .on('click', '[data-quantity]', function (e) {
            e.preventDefault();

            var referencedQuantityField = $(this).closest('.quantity').find('input');
            var quantity = parseInt(referencedQuantityField.val(), 10)

            if ($(this).data('quantity') === 'plus') {
                quantity += 1;
            } else {
                quantity -= 1;
            }

            if (quantity < parseInt($(this).attr('min'), 10)) {
                quantity = $(this).attr('min');
            }

            referencedQuantityField.val(quantity).change();
        })
        .on('change keyup', '.qty', function (e) {
            var value = parseInt($(this).val(), 10)
            var min = parseInt($(this).attr('min'))

            if (isNaN(value) && e.type === 'keyup') {
                return;
            }

            if (isNaN(value) || value < min) {
                value = min;
            }

            $(this).val(value)

            $(document).trigger('quantity-change', {
                source: $(this)
            })
        })
        .on('click', '[data-url]', function (e) {
            if (!$(this).data('url')) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            window.location = $(this).data('url');
        });

    const triggerCheckoutSelectors = [
        'select.packing_option',
        'input[name^="packing_option"]',
        'select.optional_shipping_option',
        'input[name^="optional_shipping_option"]',
        'select.optional_shipping_option',
        'input[name^="optional_shipping_option"]',
        'select.not_home_option',
        'input[name^="not_home_option"]',
    ];

    $('form.checkout').on('change', triggerCheckoutSelectors.join(', '), function () {
        $(document.body).trigger('update_checkout');
    })

    getDynamicInformation($);
})

window.display_price = function (price) {
    var formatter = new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return jQuery('<span>')
        .addClass('woocommerce-Price-amount amount')
        .append(
            jQuery('<bdi>')
                .append(
                    jQuery('<span>').addClass('woocommerce-Price-currencySymbol')
                        .html('&euro; ')
                ).append(
                formatter.format(price)
            )
        )
        .html()
}

window.convertUnitValue = function (value, unit, requiredUnit) {
    value = convertFloat(value);

    // Same does not need any conversion
    if (unit === requiredUnit) {
        return value;
    }

    return Math.floor(value * getConversionValue(unit)) / getConversionValue(requiredUnit);
}

window.getConversionValue = function (unitType) {
    var conversionValue = 1;
    unitType = unitType.toLowerCase();

    switch (unitType) {
        case 'mm':
            conversionValue = 1;
            break;
        case 'cm':
            conversionValue = 10;
            break;
        case 'm':
        default:
            conversionValue = 1000;
            break;
    }

    return conversionValue;
}

window.convertFloat = function (value) {
    if (typeof value === 'string') {
        let matches = value.match(/^([0-9]+)[\,|\.]([0-9]{0,2})$/)

        if (matches) {
            value = matches[1] + '.' + matches[2];
        }
    }

    return parseFloat(value);
}

/**
 * Some data should be loaded dynamically this function loads it via ajax
 *
 * @param $
 */
function getDynamicInformation($)
{
    let isProduct = false;
    let postId = 0;

    if ($('body').hasClass('single-product')) {
        isProduct = true;
        postId = $('[name=add-to-cart]').val()
    }

    $.ajax({
        type: "POST",
        dataType: "json",
        url: "/wp-admin/admin-ajax.php",
        data: {
            action: "dynamic_information",
            isProduct: isProduct,
            postId: postId
        },
        success: function (response) {
            $('#opening-hours').html(response.openingHours);

            if (!response.cart.empty) {
                $('.mini-cart').append(
                    $('<span>').addClass('counter')
                        .html(response.cart.contentsCount)
                );
            }

            if (isProduct && response.product.deliveryTime) {
                $('#deliveryTime').replaceWith(response.product.deliveryTime);
            }
        }
    });
}